import {
  Dialog,
  DialogHeader,
  DialogProps,
  Box,
  DialogContent,
  InputText,
  DialogFooter,
  Button,
  Text,
  Stack,
  InputGroup,
  FormLabel,
  InputMessage,
} from "@aksara-ui/react";
import { Field, FieldProps, Form, Formik, FormikValues } from "formik";
import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import * as yup from "yup";
import ImageDropzone from "components/ImageDropzone";
import { getManualReceiptRaffle } from "redux/actions";

const FormWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const initialValues = {
  phoneNumber: "",
};

const RaffleOcrGetManualForm: React.FC<DialogProps> = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const formikRef = useRef<FormikValues>() as any;

  const [fileImageReceipt, setFilesImageReceipt] = useState<any>([]);

  const { isFormLoading } = useSelector((state: any) => state.tierReducer);

  const handleCloseModal = () => {
    onClose && onClose();
    setFilesImageReceipt([]);
  };

  const handleSubmit = (values: any) => {
    const { phoneNumber } = values;

    const imageReceipt =
      typeof fileImageReceipt[0] === "object" ? fileImageReceipt[0] : null;

    dispatch(
      getManualReceiptRaffle(
        { phoneNumber, imageReceipt },
        handleCloseModal
      ) as any
    );
  };

  const validationSchema = yup.object({
    phoneNumber: yup
      .number()
      .typeError("That doesn't look like a phone number")
      .positive("A phone number can't start with a minus")
      .integer("A phone number can't include a decimal point")
      .required("Phone Number is required field"),
  });

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
      overflowY={"auto"}
    >
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => {
          return (
            <Form>
              <DialogHeader>
                <Text fontWeight={700}>{"Get Receipt Raffle"}</Text>
              </DialogHeader>
              <DialogContent>
                <FormWrapper>
                  <Field name="phoneNumber">
                    {({ field, meta }: FieldProps<string>) => (
                      <Stack spacing="xs">
                        <FormLabel htmlFor="phoneNumber">
                          Phone Number
                        </FormLabel>
                        <InputGroup inputSize={40}>
                          <InputText
                            type="tel"
                            size={40}
                            errors={!!meta.error && meta.touched}
                            {...field}
                          />
                        </InputGroup>
                        {!!meta.error && meta.touched && (
                          <InputMessage variant="error">
                            {meta.error}
                          </InputMessage>
                        )}
                      </Stack>
                    )}
                  </Field>

                  <Stack spacing="md">
                    <Stack spacing="xs">
                      <FormLabel>Upload Image Receipt</FormLabel>
                      <ImageDropzone
                        files={fileImageReceipt}
                        setFiles={setFilesImageReceipt}
                      />
                    </Stack>
                  </Stack>
                </FormWrapper>
              </DialogContent>
              <DialogFooter>
                <Stack
                  display="flex"
                  flexDirection="row"
                  spacing="xs"
                  flex={1}
                  style={{ gap: 15 }}
                >
                  <Button
                    block
                    variant="outline"
                    onClick={() => handleCloseModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    block
                    variant="primary"
                    isLoading={isFormLoading}
                  >
                    {"Load Receipt Data"}
                  </Button>
                </Stack>
              </DialogFooter>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default RaffleOcrGetManualForm;
